export default "__VITE_ASSET__a8c9592f__"